import { type AxiosResponse } from 'axios'

import axiosInstance from 'api/axiosInstance'
import { addToast } from 'components/Toast/Toast'

 

export const w9taxform = async (payload: any) => {
    try {
        const { data } = await axiosInstance({
            method: 'POST',
            url: '/api/user/document/w9',
            data: payload
        })
        return data
    } catch (error: any) {
        console.error('Error submitting form:', error)
        const errorMessage = error.response?.data?.messages
            ? Object.values(error.response.data.messages).join(', ')
            : 'An error occurred while submitting the form. Please try again.'
       addToast('error', errorMessage)
    }
}

export const getW9taxform = async () => {
    try {
        const { data } = await axiosInstance({
            method: 'GET',
            url: '/api/user/document/w9',
        });

        return { success: true, data };
    } catch (error: any) {
        console.error('Error fetching W-9 form:', error);
    }
};

export const W8Ben = async (payload: any) => {
    try {
        const { data } = await axiosInstance({
            method: 'POST',
            url: '/api/user/document/w8ben',
            data: payload
        })
        return data
    } catch (error: any) {
        console.error('Error submitting form:', error)
        const errorMessage = error.response?.data?.messages
            ? Object.values(error.response.data.messages).join(', ')
            : 'An error occurred while submitting the form. Please try again.'
        addToast('error', errorMessage)
    }
}

export const getW8Bentaxform = async () => {
    try {
        const { data } = await axiosInstance({
            method: 'GET',
            url: '/api/user/document/w8ben',
        });

        return { success: true, data };
    } catch (error: any) {
        console.error('Error fetching W-9 form:', error);
    }
};
export const dac7 = async (payload: any) => {
    try {
        const { data } = await axiosInstance({
            method: 'POST',
            url: '/api/user/document/dac7',
            data: payload
        })
        return data
    } catch (error: any) {
        console.error('Error submitting form:', error)
        const errorMessage = error.response?.data?.messages
            ? Object.values(error.response.data.messages).join(', ')
            : 'An error occurred while submitting the form. Please try again.'
        addToast('error', errorMessage)
    }
}


export const getDac7taxform = async () => {
    try {
        const { data } = await axiosInstance({
            method: 'GET',
            url: '/api/user/document/dac7',
        });
 
        return { success: true, data };
    } catch (error: any) {
        console.error('Error fetching dac7 form:', error);
    }
};

